// Drop-in for polished/lib/color/toColorString (aliased in craco.config.js):
// a KDS token resolves to its CSS variable so the palette follows [data-theme];
// anything else passes through. Jest is not aliased, tests see literal colours.
// eslint-disable-next-line import/extensions -- the extension dodges the `$` alias
import realToColorString from 'polished/lib/color/toColorString.js';
import { VAR_KEY, baseVarFor, varNameFor } from './bootstrap';

const isColor = (o) => o && typeof o === 'object' && typeof o.red === 'number';

const sameAlpha = (a, b) => (a ?? 1) === (b ?? 1);

export default function toColorString(colorValue) {
  if (!isColor(colorValue)) return realToColorString(colorValue);
  const tagged = colorValue[VAR_KEY] || varNameFor(colorValue);
  if (!tagged) return realToColorString(colorValue);

  const { name, alpha } = tagged;
  if (sameAlpha(alpha, colorValue.alpha)) return `var(${name})`;

  // Re-tinted copy (`{ ...token, alpha }`): mix from the alpha-less base so an
  // opacity token's own alpha is not applied twice; no base → literal.
  const base = baseVarFor(colorValue);
  if (!base) return realToColorString(colorValue);
  const pct = Math.round((colorValue.alpha ?? 1) * 100);
  return `color-mix(in srgb, var(${base}) ${pct}%, transparent)`;
}
